<!--Pass Info-->
<div class="ItemBorder LockToTop">
	<h4 style="text-align: center">Visitor Information:</h4>

	<div class="CenterFlex">
		<!--Left Col-->
		<div>
			<img class="VisitorImage" [src]="VisitorPhoto" />
		</div>

		<!--Right Col-->
		<div class="InfoGrid">
			<label>First Name:</label>
			<p>{{ FirstName }}</p>

			<label>License Number:</label>
			<p>{{ LicenseNbr }}</p>

			<label>Last Name:</label>
			<p>{{ LastName }}</p>

			<label>Driver's License State:</label>
			<p>{{ State }}</p>

			<label>Address:</label>
			<p>{{ Address }}</p>

			<label>Email:</label>
			<p>{{ Email }}</p>

			<label>City:</label>
			<p>{{ City }}</p>

			<label>Phone:</label>
			<p>{{ PhoneNbr }}</p>

			<label>Zip:</label>
			<p>{{ ZipCode }}</p>

			<label>Visitor Notes (If Pre-Registered):</label>
			<p>{{ VisitorNotes }}</p>

			<label>Check In Facility:</label>
			<p>{{ CheckInFacilityName }}</p>

			<label>Check In Time:</label>
			<p>{{ VisitorPassDTDesc }}</p>

			<label>Check In Location:</label>
			<p>{{ CheckInFacilityLocationName }}</p>

			<label>Entry Notes:</label>
			<p>{{ PassComments }}</p>
		</div>
	</div>
</div>

<!--Offender Hits-->
<div class="ItemBorder TopMargin">
	<caass-ms-visitor-offender-lookup [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-offender-lookup>
</div>
